/* eslint-disable react-native/no-inline-styles */

import {View} from 'react-native';
import Text from '@basicComponents/text';
import {basicColor, flex, fontSize} from '@/components/style';
import React from 'react';
import LazyImage from '@/components/basic/image';
import {AxiosResponse} from 'axios';
import {useScreenSize} from '@/common-pages/hooks/size.hooks';
import VipSmall from '../vip/vip-small';
import {defaultHeaderImg} from '@/pages/me/me.variable';
export interface userInfoObj extends AxiosResponse {
  level: 7;
  userAvatar: 'https://lottery-india.oss-ap-south-1.aliyuncs.com/manager/d0ba712abfc6401eb366b860796c5e82.png';
  userInviteCode: 'ZPZVOW';
  userName: 'because';
}
const BetsShardUser = ({
  userInfo,
  notDrawn = false,
}: {
  userInfo: userInfoObj;
  notDrawn?: boolean;
}) => {
  const {calcActualSize} = useScreenSize();
  return userInfo === undefined ? (
    <></>
  ) : (
    <View
      style={[
        flex.flex,
        flex.row,
        flex.centerByCol,
        notDrawn ? flex.start : flex.centerByRow,
        {
          gap: calcActualSize(12),
        },
      ]}>
      <View
        style={[
          {
            width: calcActualSize(40),
            height: calcActualSize(40),
            overflow: 'hidden',
            borderRadius: calcActualSize(40),
            borderWidth: 1,
            borderColor: '#fff',
          },
        ]}>
        <LazyImage
          imageUrl={
            userInfo?.userAvatar ? userInfo?.userAvatar : defaultHeaderImg
          }
          occupancy="#0000"
          width={calcActualSize(40)}
          height={calcActualSize(40)}
        />
      </View>
      <View
        style={[
          flex.flex,
          flex.row,
          flex.centerByCol,
          {
            gap: calcActualSize(8),
          },
        ]}>
        <Text
          calc
          color={basicColor.white}
          fontSize={fontSize.m}
          blod
          fontFamily="fontInter">
          {userInfo?.userName}
        </Text>
        <VipSmall level={userInfo?.level} className="h-[1.25rem]" />
      </View>
    </View>
  );
};
export default BetsShardUser;
